import VerticalNavigation from './VerticalNavigation';
import 'eksenia-lib/src/VerticalNavigation/VerticalNavigation.scss';

export default VerticalNavigation
